.v{justify-content:center;}